import { CreditCard } from 'lucide-react';
import { SiApplepay } from 'react-icons/si';
import { CiBank } from 'react-icons/ci';
import { FaGooglePay } from 'react-icons/fa';
import { TbBrandCoinbase } from 'react-icons/tb';
import classNames from '@/lib/misc/classNames';
import { useDetectPlatform } from '@/hooks/utilities/useDetectPlatform';
import { Button } from '../ui/button';
import usePaymentProvider from '@/hooks/deposit/usePaymentProvider';
import useAppDetails from '@/hooks/utilities/useAppDetails';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import useGetLocation from '@/hooks/utilities/useGetLocation';
export default function PaymentOptions() {
  const platform = useDetectPlatform();
  const {
    isNativeApp
  } = useAppDetails();
  const {
    paymentProviders,
    paymentProvider,
    setPaymentProvider,
    setSelectedPaymentMethod,
    selectedDropDownOption,
    setSelectedDropDownOption,
    dropDownOptions
  } = usePaymentProvider();
  const {
    geoState
  } = useGetLocation();
  return <div className='ta-l mt-4  ' data-sentry-component="PaymentOptions" data-sentry-source-file="PaymentOptions.tsx">
      <div className='flex items-center mx-4 mb-2 p-1 justify-between border border-genius-blue rounded-md text-sm'>
        {paymentProviders?.map((x, index) => {
        return <div key={index} className={classNames('flex items-center justify-center  w-full rounded-md px-2 py-1 cursor-pointer ', paymentProvider === x ? 'bg-genius-blue' : 'bg-genius-indigo')} onClick={() => {
          if (x === 'Crypto Wallet') {
            setPaymentProvider('Crypto Wallet');
            setSelectedPaymentMethod('evm');
          } else {
            setPaymentProvider(x);
          }
        }}>
              {x}{' '}
            </div>;
      })}
      </div>
      {paymentProvider === 'Other' && <div className='mx-4 mb-2 flex items-center justify-start text-sm text-genius-cream/50 mt-4'>
          <div className='mr-2'>Options:</div>
          <Select onValueChange={setSelectedDropDownOption} defaultValue={selectedDropDownOption}>
            <SelectTrigger className='bg-genius-blue text-genius-cream rounded-full w-fit px-4 border-none'>
              <SelectValue placeholder='Select Provider' />
            </SelectTrigger>
            <SelectContent className='bg-genius-blue text-genius-cream' style={{
          zIndex: 9999
        }}>
              {dropDownOptions.map(x => <SelectItem key={x} value={x}>
                  {x}
                </SelectItem>)}
            </SelectContent>
          </Select>
        </div>}

      {platform == 'ios' && isNativeApp && <div style={{
      paddingBottom: '0px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '0px'
    }} className={`min-h-[54px] h-fit  flex items-center text-genius-cream text-[16px] hover:bg-genius-blue rounded-md cursor-pointer justify-between  p-0 pb-0 mb-0`}>
          <div className='flex flex-col items-start justify-between w-full'>
            <Button variant='ghost' type='button' disabled={geoState == 'NY'} onClick={() => setSelectedPaymentMethod('apple')} className={classNames('flex justify-between w-full px-0')}>
              <div className='flex items-center justify-start text-[16px]'>
                <SiApplepay className='w-[22px] h-[22px] mr-2' />
                Apple Pay
              </div>
              {geoState == 'NY' && <p className='text-[12px]'>Coming Soon to NY</p>}
            </Button>
          </div>
        </div>}
      {platform == 'android' && paymentProvider != 'Coinbase' && isNativeApp && <div style={{
      paddingBottom: '0px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '0px'
    }} className={`min-h-[54px] h-fit  flex items-center text-genius-cream text-[16px] justify-between hover:bg-genius-blue rounded-md cursor-pointer  p-0 pb-0 mb-0`}>
          <div className='flex flex-col items-start justify-between w-full'>
            <Button variant='ghost' type='button' disabled={geoState == 'NY'} onClick={() => setSelectedPaymentMethod('google')} className='flex justify-between w-full px-0'>
              <div className='flex items-center justify-start text-[16px]'>
                <FaGooglePay className='w-[22px] h-[22px] mr-2' />
                Google Pay
              </div>
              {geoState == 'NY' && <p className='text-[12px]'>Coming Soon to NY</p>}
            </Button>
          </div>
        </div>}

      <div style={{
      paddingBottom: '0px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '0px'
    }} className={`min-h-[54px] h-fit  flex items-center text-genius-cream text-[16px] justify-between   p-0 pb-0 mb-0 hover:bg-genius-blue rounded-md cursor-pointer`}>
        <div className='flex flex-col items-start justify-between w-full'>
          <Button variant='ghost' type='button' onClick={() => setSelectedPaymentMethod('card')} className='flex justify-between w-full px-0' data-sentry-element="Button" data-sentry-source-file="PaymentOptions.tsx">
            <div className='flex items-center justify-start text-[16px]'>
              <CreditCard className='w-[22px] h-[22px] mr-2 ' data-sentry-element="CreditCard" data-sentry-source-file="PaymentOptions.tsx" />
              Credit | Debit
            </div>
          </Button>
        </div>
      </div>

      <div style={{
      paddingBottom: '0px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '0px'
    }} className={`min-h-[54px] h-fit  flex items-center text-genius-cream text-[16px] justify-between p-0 pb-0 mb-0 hover:bg-genius-blue rounded-md cursor-pointer`}>
        <div className='flex flex-col items-start justify-between w-full'>
          <Button variant='ghost' type='button' onClick={() => setSelectedPaymentMethod('bank')} className='flex justify-between w-full px-0' data-sentry-element="Button" data-sentry-source-file="PaymentOptions.tsx">
            <div className='flex items-center justify-start text-[16px]'>
              <CiBank className='w-[22px] h-[22px] mr-2' data-sentry-element="CiBank" data-sentry-source-file="PaymentOptions.tsx" />
              Bank Account
            </div>
          </Button>
        </div>
      </div>
      {paymentProvider == 'Coinbase' || selectedDropDownOption == 'Coinbase' && paymentProvider == 'Other' && <div style={{
      paddingBottom: '0px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '0px'
    }} className={`min-h-[54px] h-fit  flex items-center text-genius-cream text-[16px] justify-between   p-0 pb-0 mb-0 hover:bg-genius-blue rounded-md cursor-pointer`}>
            <div className='flex flex-col items-start justify-between w-full'>
              <Button variant='ghost' type='button' onClick={() => setSelectedPaymentMethod('coinbase_account')} className='flex justify-between w-full px-0'>
                <div className='flex items-center justify-start text-[16px]'>
                  <TbBrandCoinbase className='w-[22px] h-[22px] mr-2 ' />
                  Coinbase Account
                </div>
              </Button>
            </div>
          </div>}
    </div>;
}